export default __webpack_public_path__ + "static/media/back.b5f8f43e.svg";